<app-filter-button
	[attr.notranslate]="false"
	[title]="getDateText(this.selectedRange.start, this.selectedRange.end)"
	(buttonClick)="openDateTimePicker($event)"
	[filter]="false"
	[openedFilter]="false">
</app-filter-button>
